import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { OccupancyMonthResponseSchema } from "../response/OccupancyMonthResponse";

interface Filter {
    start: string;
    end: string;
    property_id: string;
    room_type_id?: string;
}

// [PERUBAHAN 1] Tambahkan 'group_by'
interface OccupancyParams {
    filter?: Filter;
    group_by?: 'month' | 'room_type';
    enabled?: boolean;
}

const API_VERSION = 'v4';

const useOccupancyMonth = (query: OccupancyParams) => {
    return useQuery({
        // [PERUBAHAN 2] Lengkapi queryKey
        queryKey: [
            'bookings', 'monthly', 'occupancy',
            query.filter?.property_id,
            query.filter?.start,
            query.filter?.end,
            query.filter?.room_type_id,
            query.group_by
        ],
        queryFn: async () => {
            // [PERUBAHAN 3] Susun params dengan benar (dan hapus try-catch yang tidak perlu)
            const params = {
                filter: query.filter,
                group_by: query.group_by
            };
            const response = await privateApi.get(`/${API_VERSION}/occupancy-monthly`, { params });
            const validationResult = OccupancyMonthResponseSchema.safeParse(response.data);
            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid Occupancy month data format");
            }
            return validationResult.data;
        },
        enabled: query.enabled !== false && !!query.filter?.property_id,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useOccupancyMonth;